<template>
    <div>
        <v-toolbar dense color="primary" flat dark>
            <v-toolbar-title>Espera Urgencias ({{movimientosTotal}})</v-toolbar-title>
            <v-spacer/>
            <v-btn @click="busca">
                Buscar
            </v-btn>
            <v-btn @click="exporta" class="ml-2">
                Exportar
            </v-btn>
        </v-toolbar>
        <v-sheet class="pa-2" elevation="2">
            <v-row no-gutters>
                <v-col md=3 cols="12">
                    <v-date-picker
                        v-model="fechaPicker"
                        range
                        full-width
                        no-title
                        scrollable
                        :max="estaFecha"
                        locale="es-mx"
                    />
                </v-col>
                <v-col md=9 cols="12">

                </v-col>
            </v-row>
            <v-data-table
                class="mt-2"
                :headers="headers"
                :items="movimientosTodos"
                hide-default-footer
                item-key="id"
                :loading="loadingDatos"
                dense
                :server-items-length='movimientosTotal'
                disable-pagination
                :show-group-by='true'
            />
        </v-sheet>



    </div>
</template>

<script>
export default {
    mounted(){
        this.fechaPicker = [
            this.moment(new Date()).format("YYYY-MM-DD"),
            this.moment(new Date()).format("YYYY-MM-DD"),
        ]
    },
    data:()=>({
        loadingDatos:false,
        db:{},
        exportar: false,
        fechaPicker:[],
        direccion:'',

        headers:[
            { text: 'Llega', value: 'llega', align:'center', groupable:false},
            { text: 'Atiende', value: 'atiende', align:'center', groupable:false},
            { text: 'Espera', value: 'espera', align:'center', width:'40px', groupable:false},
            { text: 'C.I.P.', value: 'cip_id', align:'center'},
            { text: 'sexo', value: 'genero', align:'center', width:'40px'},
        ],
        movimientosTodos:[],
        movimientosTotal:0,
    }),
    methods:{
        async busca(){
            this.loadingDatos = true
            try{
                this.loadingDatos = false
                const req = await this.$http({
                    method:"POST",
                    url: '/reportes/reporteEsperaUrgencias',
                    params:this.db,
                })
                this.loadingDatos=false
                //console.log(req.data)
                this.movimientosTodos=req.data.root
                this.movimientosTotal=req.data.total

            } catch(err){
                this.$store.dispatch('security/revisaError',err)
                this.loadingDatos = false
            }
        },
        async exporta() {
        try {
            this.loadingDescarga = true

            const req = await this.$http({
                url: '/reportes/exportaReporteEsperaUrgencias',
                timeout: 600000,
                method: 'GET',  // O POST si tu backend lo requiere
                params: {
                    ...this.db,
                    _format: 'XLSX',
                    _name: 'ReporteEsperaUrge',
                    _file: 'reporteEsperaUrge'
                },
                responseType: 'arraybuffer'
            })

            this.loadingDescarga = false

            // Crea Blob y descarga el archivo
            const headers = req.headers
            const blob = new Blob([req.data], { type: headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'ReporteEsperaUrge.xlsx'
            link.click()

        } catch (err) {
            this.loadingDescarga = false
            this.$store.dispatch('security/revisaError', err)
        }
}
,
    },
    computed:{
        estaFecha(){
            return (this.moment(new Date()).format('YYYY-MM-DD'))
        },
    },
    watch:{
        fechaPicker(){
            let far=[]
            // this.fechaArr = []
            if(this.fechaPicker.length > 0){
                this.fechaPicker.forEach(fecha => {
                    far.push(new Date(fecha+'T00:00:00'))
                })

                this.db.fechaDe = this.moment(new Date(Math.min.apply(null,far))).format("DD-MM-YYYY")
                this.db.fechaA = this.moment(new Date(Math.max.apply(null,far))).format("DD-MM-YYYY")
            }
        },
    },
}
</script>

<style>

</style>